<template>
	<div class="bottom-item-editor">
		<AppBottomSheet :forceWidth="bottomSheetWidth" :active="!!counterStore.editingItem" @toggling-popup="v => { if(!v) {counterStore.editingItem = null} }" >
			<div class="bottom-item-editor-content" v-if="!!counterStore.editingItem">
				<ModalHeader :title="itemTitle" />
				<AppList :items="items">
					<template #number-input-slot="{item}">
						<div class="row centered space-between">
							<p class="number-p">{{item.title}}</p>
							<TouchNumberInput class="input-item" :min="item.min" :max="item.max" :value="item.value" @changed-value="v=>{item.valueCallback(v)}" />
						</div>
					</template>
					<template #textarea-slot="{item}">
						<div class="row flex-start space-between item-textarea-container">
							<p>{{item.title}}</p>
							<AppTextInput textarea class="input-item input-item-textarea" :placeholder="item.placeholder" :value="item.value" @changing-text="v=>{item.valueCallback(v)}" />
						</div>
					</template>
					<template #item-total="{item}">
						<div class="row centered space-between">
							<p class="number-p-2">{{item.title}}</p>
							<div class="item-total-container" @click="showPriceEdit">
								<div class="item-price-full" v-if="counterStore.editingItem && counterStore.editingItem.hasOwnProperty('fullPrice')">{{ currencyStore.readableCurrencyValue(counterStore.editingItem.fullPrice, true, false) }}</div>
								<p class="item-total">{{ currencyStore.readableCurrencyValue(item.price, true, false) }}</p>
							</div>
						</div>
					</template>
				</AppList>
			</div>
		</AppBottomSheet>
		<BottomNumberEditor :active="priceEdit" :title="itemTitle+' ('+currencyStore.currCurrency.symbol+')'" :start-price-name="getString('price')" :starting-number="itemPrice" @toggling-popup="togglingPrice" @confirm-number="confirmPrice" />
	</div>
</template>

<script>
import AppBottomSheet from "@/shared/components/AppBottomSheet.vue";
import WindowWidth from "@/console-new/mixins/WindowWidth";
import {useCurrencyStore, useLanguageStore} from "@/shared/stores";
import {useCounterStore} from "@/console-new/stores/counter.store";
import AppList from "@/shared/components/AppList.vue";
import ModalHeader from "@/console-new/components/shared/ModalHeader.vue";
import TouchNumberInput from "@/console-new/components/shared/TouchNumberInput.vue";
import BottomNumberEditor from "@/console-new/components/ops/counter/BottomNumberEditor.vue";
import AppTextInput from "@/shared/components/AppTextInput.vue";
import {useUserStore} from "@/console-new/stores";

export default {
	setup() {
		let languageStore = useLanguageStore();
		const counterStore = useCounterStore();
		const userStore = useUserStore();
		const currencyStore = useCurrencyStore();
		return {getString: languageStore.getString, counterStore, currencyStore, userStore};
	},
	name: "BottomItemEditor",
	components: {BottomNumberEditor, TouchNumberInput, ModalHeader, AppList, AppBottomSheet, AppTextInput},
	mixins: [WindowWidth],
	data() {
		return {
			priceEdit: false,
		}
	},
	computed: {
		itemTitle() {
			return this.counterStore.editingItem ? this.counterStore.editingItem.name : '';
		},
		itemPrice() {
			if(this.counterStore.editingItem) {
				if(this.counterStore.editingItem.hasOwnProperty('fullPrice')) {
					return this.counterStore.editingItem.fullPrice;
				} else {
					return this.counterStore.editingItem.price;
				}
			} else {
				return 0;
			}
		},
		bottomSheetWidth() {
			if(this.windowWidth < 550) {
				return "100%";
			} else if(this.windowWidth < 768) {
				return "550px";
			} else {
				return "720px";
			}
		},
		items() {
			if(!this.counterStore.editingItem) {
				return [];
			}
			let items = [];
			if(this.counterStore.editingItem.quantity > 1) {
				items.push({
					uniqueId: 'split',
					title: this.getString("split_items"),
					buttonTitle: this.getString("split"),
					callbackButton: () => {
						this.counterStore.splitItem(this.counterStore.editingItem);
						this.counterStore.editingItem = null;
					}
				})
			}
			items.push({uniqueId: 'quantity', title: this.getString("quantity"), customSlot: 'number-input-slot', value: this.counterStore.editingItem.quantity, min: 0, max: 9999, valueCallback: v => {
				if(v === 0) {
					this.counterStore.removeCartItem(this.counterStore.editingItem, this.counterStore.editingItem.quantity);
					this.counterStore.editingItem = null;
				} else {
					this.counterStore.editingItem.quantity = v;
				}
			}});
			if(this.counterStore.withCourses) {
				items.push({title: this.getString("course"), customSlot: 'number-input-slot', value: this.counterStore.editingItem.course, min: 1, max: 100, valueCallback: v => {
					this.counterStore.editingItem.course = v;
					this.counterStore.maxCourse = Math.max(this.counterStore.maxCourse, v);
					this.counterStore.removeUnusedCourses(v);
				}});
			}
			items.push({title: this.getString("unit_price_x", [this.currencyStore.currCurrency.symbol]), customSlot: 'item-total', price: this.counterStore.editingItem.price});
			items.push({title: this.getString("product_notes"), customSlot: 'textarea-slot', value: this.counterStore.editingItem.note, placeholder: this.getString('notes'), valueCallback: v => {
				this.counterStore.editingItem.note = v && v.length > 0 ? v : null;
			}});
			return items;
		},
	},
	methods: {
		togglingPrice(isOpen) {
			if(!isOpen) {
				this.priceEdit = false;
			}
		},
		confirmPrice(number) {
			if(!this.counterStore.editingItem.hasOwnProperty('fullPrice')) {
				this.counterStore.editingItem.fullPrice = this.counterStore.editingItem.price;
			}
			this.counterStore.editingItem.price = number;
			if(this.counterStore.editingItem.fullPrice === this.counterStore.editingItem.price) {
				delete this.counterStore.editingItem.fullPrice;
			}
			this.priceEdit = false;
		},
		showPriceEdit() {
			if(this.userStore.checkOrderDiscountAllowed){
				this.priceEdit = true;
			}
		}
	},
}
</script>

<style scoped lang="scss">
.number-p {
	gap: 10px;
}
.number-p-2 {
	gap: 10px;
}
.input-item {
	@media (max-width: 350px) {
		margin-left: auto;
	}
}
.item-total-container {
	display: flex;
	align-items: center;
	margin-left: auto;
	padding: 8px 12px;
	background-color: var(--color-bg-primary-2);
	border-radius: 13px;
	cursor: pointer;

	.item-price-full {
		font-size: 12px;
		color: var(--color-txt-1);
		text-decoration: line-through;
	}

	.item-total {
		font-size: 20px;
		color: $primary;
		font-weight: 700;
		user-select: none;
		padding: 4px;
	}
}
.number-p {
	@media (max-width: 600px) {
		font-size: 14px;
	}
	@media (max-width: 400px) {
		font-size: 12px;
	}
	@media (max-width: 350px) {
		width: 100%;
		margin-bottom: 6px;
	}
}
.item-textarea-container {
	gap: 10px;

	.input-item-textarea {
		margin-left: auto;
	}
}
</style>